// ラジオボタン値
export type RadioVal = '' | '1';

/**
 * タグ集約画面のタグ情報クラス
 *
 * @export TagInfo
 * @class TagInfo
 */
export class TagInfo {
  public radioVal: RadioVal = '';
  constructor(public tagId: string, public tagName: string) {}
}
